import { CheckCircle, Target } from 'lucide-react';

interface Strength {
  line: string;
  comment: string;
}

interface Opportunity {
  line: string;
  comment: string;
}

interface StrengthsOpportunitiesProps {
  strengths: Strength[];
  opportunities: Opportunity[];
  isDarkMode: boolean;
}

export default function StrengthsOpportunities({ strengths, opportunities, isDarkMode }: StrengthsOpportunitiesProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className={`rounded-xl p-6 border ${
        isDarkMode 
          ? 'bg-green-900/20 border-green-700' 
          : 'bg-green-50 border-green-300'
      }`}>
        <h4 className={`font-semibold mb-4 text-lg flex items-center ${
          isDarkMode ? 'text-green-400' : 'text-green-700'
        }`}>
          <CheckCircle className="w-5 h-5 mr-2" />
          Top Strengths
        </h4>
        <div className="space-y-3">
          {strengths?.map((strength, index) => (
            <div key={index} className="border-l-2 border-green-500 pl-3">
              <div className={`text-xs font-mono ${
                isDarkMode ? 'text-green-300' : 'text-green-600'
              }`}>{strength.line}</div>
              <div className={`text-sm ${
                isDarkMode ? 'text-gray-300' : 'text-[#373737]'
              }`}>
                {strength.comment}
              </div>
            </div>
          )) || <div className="text-gray-400">No strengths identified</div>}
        </div>
      </div>

      <div className={`rounded-xl p-6 border ${
        isDarkMode 
          ? 'bg-yellow-900/20 border-yellow-700' 
          : 'bg-yellow-50 border-yellow-300'
      }`}>
        <h4 className={`font-semibold mb-4 text-lg flex items-center ${
          isDarkMode ? 'text-yellow-400' : 'text-yellow-700'
        }`}>
          <Target className="w-5 h-5 mr-2" />
          Key Opportunities
        </h4>
        <div className="space-y-3">
          {opportunities?.map((opportunity, index) => (
            <div key={index} className="border-l-2 border-yellow-500 pl-3">
              <div className={`text-xs font-mono ${
                isDarkMode ? 'text-yellow-300' : 'text-yellow-600'
              }`}>{opportunity.line}</div>
              <div className={`text-sm ${
                isDarkMode ? 'text-gray-300' : 'text-[#373737]'
              }`}>
                {opportunity.comment}
              </div>
            </div>
          )) || <div className="text-gray-400">No opportunities identified</div>}
        </div>
      </div>
    </div>
  );
}
